export default __webpack_public_path__ + "static/media/PERSO_1.db2dc59c.gif";